/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Settings_MembersInputs */

const en_admin_resource_form_settings_members = /** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings (Members)`)
};

const de_admin_resource_form_settings_members = /** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen (Mitglieder)`)
};

const es_admin_resource_form_settings_members = /** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración (Miembros)`)
};

const fr_admin_resource_form_settings_members = /** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres (Membres)`)
};

/** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */
const it_admin_resource_form_settings_members = en_admin_resource_form_settings_members;

/** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */
const pt_br2_admin_resource_form_settings_members = en_admin_resource_form_settings_members;

/** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */
const pl_admin_resource_form_settings_members = en_admin_resource_form_settings_members;

/** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */
const hu_admin_resource_form_settings_members = en_admin_resource_form_settings_members;

/** @type {(inputs: Admin_Resource_Form_Settings_MembersInputs) => LocalizedString} */
const ro_admin_resource_form_settings_members = en_admin_resource_form_settings_members;

/**
* | output |
* | --- |
* | "Settings (Members)" |
*
* @param {Admin_Resource_Form_Settings_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_settings_members = /** @type {((inputs?: Admin_Resource_Form_Settings_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Settings_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_settings_members(inputs)
	if (locale === "de") return de_admin_resource_form_settings_members(inputs)
	if (locale === "es") return es_admin_resource_form_settings_members(inputs)
	if (locale === "fr") return fr_admin_resource_form_settings_members(inputs)
	if (locale === "it") return it_admin_resource_form_settings_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_settings_members(inputs)
	if (locale === "pl") return pl_admin_resource_form_settings_members(inputs)
	if (locale === "hu") return hu_admin_resource_form_settings_members(inputs)
	return ro_admin_resource_form_settings_members(inputs)
});
export { admin_resource_form_settings_members as "admin.resource_form.settings_members" }